module.exports = [
  ...require('./_magicItemRawList_DMG_c'),
  require('./candle_of_invocation'),
  require('./cloak_of_elvenkind'),
]
